import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import history from './history';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import './index.css';
import { customTheme } from './CustomTheme';
import App from './App';
import store from './store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { msalConfig } from './config/authConfig';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

const startApp = async () => {
	const msalInstance = new PublicClientApplication(msalConfig);
	
	if (window.location.pathname === "/fcl") {
		await frontChannelLogout(msalInstance);
	}
	else {
			ReactDOM.render(
					<MsalProvider instance={msalInstance}>
							<Provider store={store}>
								<MuiThemeProvider theme={customTheme}>
									<Router history={history}>
										<App />
									</Router>
								</MuiThemeProvider>
							</Provider>
					</MsalProvider>,
				document.getElementById('root')
			);
	}

	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: https://bit.ly/CRA-PWA
	serviceWorker.unregister();
}

const frontChannelLogout = async (msalInstance) => {
	msalInstance.logoutRedirect({ postLogoutRedirectUri: "/" })
}

startApp();